import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createReducer } from '@reduxjs/toolkit';
import type { Pixel } from 'types/actions/tracking';

export const createPixel = createAction<Pixel, 'createPixel'>('createPixel');

const init = {
  pixels: {},
};

export const trackingReducer = createReducer(init, (builder) =>
  builder.addCase(createPixel, (state, { payload }: PayloadAction<Pixel>) => {
    if (state?.pixels?.[payload.source]) return state;

    return {
      ...state,
      pixels: { ...state.pixels, [payload.source]: payload.src },
    };
  })
);
